import { FC } from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';

import { PiiMatchFragment } from '../../graphql/generated';
import { sortByProp, SortOrder } from '../../utils/sorting/sorting';

export const getTotalMatchOccurrences = (matches: PiiMatchFragment[]): number =>
  matches.reduce((acc, match) => acc + match.count, 0);

export const PiiMatches: FC<{ matches: PiiMatchFragment[] }> = ({
  matches,
}) => {
  const totalOccurrences = getTotalMatchOccurrences(matches);
  const sortedMatches = sortByProp(matches, 'count', SortOrder.DESC);

  return (
    <Accordion allowMultiple data-testid="pii-matches">
      <AccordionItem>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            <Text fontWeight="600" data-testid="pii-total-match-count">
              {totalOccurrences} occurrences of PII were detected
            </Text>
          </Box>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel pb={4}>
          <UnorderedList ml={5}>
            {sortedMatches.map(({ infoType, count }) => (
              <ListItem
                data-testid="infotype"
                key={infoType.type}
              >
                <Text>
                  <Text as="span" fontWeight="600" data-testid="infotype-count">
                    {count}
                  </Text>{' '}
                  {count === 1 ? 'occurrence' : 'occurrences'} of{' '}
                  <Text as="span" fontWeight="600" data-testid="infotype-label">
                    {infoType.label}
                  </Text>{' '}
                </Text>
              </ListItem>
            ))}
          </UnorderedList>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
